import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationStep5 } from "./../../models/classes/ApplicationStep5.class";


export interface ApplicationStep5States {
  isCompleted:boolean,
  formData:ApplicationStep5
}

const initialState: ApplicationStep5States = {
  isCompleted:false,
  formData: new ApplicationStep5()
};


const ApplicationStep5Slice = createSlice({
  name:"Application Step 5 Slice",
  initialState,
  reducers:{
    updateFormData: (state, action: PayloadAction<ApplicationStep5>) => {
      state.formData = action.payload;
    },
    setCompleted: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    resetFormData: (state)=>{
      state.formData = new ApplicationStep5();
    }
  },
  extraReducers: {}
});


export const { updateFormData, setCompleted, resetFormData } = ApplicationStep5Slice.actions;

export default ApplicationStep5Slice.reducer;